import {GET_MODULES} from "../apollo/Queries";
import {apolloClientPos} from "../apollo/ApolloClients";

export const ONLINE_BOOKING_MODULE_NAME = "Online Booking";

export const isOnlineBookingModuleDisabled = async (companyId) => {
    try {
        const {data} = await apolloClientPos.query({
            query: GET_MODULES,
            variables: {companyId: Number(companyId)},
            fetchPolicy: "network-only",
        });

        const onlineBookingModule = data?.relations?.modules?.find(
            (module) => module.name === ONLINE_BOOKING_MODULE_NAME
        );

        return !!onlineBookingModule && onlineBookingModule.active === false;
    } catch (error) {
        return false;
    }
};
